module.exports = __webpack_public_path__ + "img/Marshall Island.307c6eb0.svg";